document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const bgVideo = document.querySelector('.bg-video');

    if (!header || !bgVideo) return;

    const setMargin = () => {
        const headerHeight = header.offsetHeight;
        bgVideo.style.marginTop = `-${headerHeight}px`;
    };

    setMargin();

    window.addEventListener('resize', setMargin);
});